import { 
    SET_LOADING,
    SET_LOCATION_LIST,
    SET_PROFILE_CATEGORY_LIST,
    SET_PROJECT_CATEGORY_LIST,
    SET_ROLE_TYPE_LIST,
    SET_KYC_MODAL,
    SET_REPORT_MODAL,
    SET_REPORT_TYPE_LIST
} from "../../actions/general/types";

const INITIAL_STATE = {
    loading: false,
    locationList: [],
    roleTypeList: [],
    profileCategoryList: [],
    projectCategoryList: [],
    reportModal: {
        open: false,
        data: null,
        type: undefined
    },
    kycModal: {
        open: false,
        profileCompleted: false,
        kycVerified: false
    },
    reportTypes: []
}

const GeneralReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        case SET_LOCATION_LIST: {
            return {
                ...state,
                locationList: action.payload
            }
        }
        case SET_ROLE_TYPE_LIST: {
            return {
                ...state,
                roleTypeList : action.payload
            }
        }
        case SET_PROFILE_CATEGORY_LIST: {
            return {
                ...state,
                profileCategoryList : action.payload
            }
        }
        case SET_PROJECT_CATEGORY_LIST: {
            return {
                ...state,
                projectCategoryList : action.payload
            }
        }
        case SET_REPORT_TYPE_LIST: {
            return {
                ...state,
                reportTypes : action.payload
            }
        }
        case SET_REPORT_MODAL: {
            return {
                ...state,
                reportModal : action.payload
            }
        }
        case SET_KYC_MODAL: {
            return {
                ...state,
                kycModal : action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default GeneralReducer;